export default "__VITE_ASSET__ee3d3aab__"